<script>
  import BookHero from '../components/Book/BookHero/BookHero.svelte';
  import ContactForm from '../components/Book/ContactForm/ContactForm.svelte';
  import SeminarCalendar from '../components/Book/SeminarCalendar/SeminarCalendar.svelte';
</script>

<main>
  <BookHero />
  <SeminarCalendar />
  <ContactForm />
</main>